<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">
        Update Active Year
      </v-card-title>
      <v-card-text class="mt-3 body-2">
        <div>
          <v-combobox
            v-model="updateData.activeYear"
            :items="years"
            hide-selected
            chips
            label="Active Year"
            multiple
            @input="$v.updateData.activeYear.$touch()"
            :error-messages="$v.updateData.activeYear.$error && `Active Year is required.`"
            @blur="$v.updateData.activeYear.$touch()"
          >
            <template v-slot:selection="{ attrs, item, parent, selected }">
              <v-chip
                v-if="item === String(item)"
                v-bind="attrs"
                :input-value="selected"
                label
                small
              >
                <span class="pr-2">
                  {{ item }}
                </span>
                <v-icon
                  small
                  @click="parent.selectItem(item)"
                >
                  $delete
                </v-icon>
              </v-chip>
              <v-chip
                v-if="item === Object(item)"
                v-bind="attrs"
                :input-value="selected"
                label
                small
              >
                <span class="pr-2">
                  {{ item.name }}
                </span>
                <v-icon
                  small
                  @click="parent.selectItem(item)"
                >
                  $delete
                </v-icon>
              </v-chip>
            </template>
          </v-combobox>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" id="close" text @click.native="close()">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="save()" :disabled="$v.updateData.$invalid">Save</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </v-dialog>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
// import campaignAPIs from '../campaignAPIs';
// import userAPIs from '../User/userAPIs';
// import config from '@/config';
// import moment from 'moment'
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
export default {
  name: 'ActiveYearModal',
  components: {
    Loading
  },
  props: {
    value: Boolean,
    campaigns: Array
  },
  validations: {
    updateData: {
      activeYear: { required }
    }
  },
  data () {
    return {
      isLoading: false,
      years: [
        '2026',
        '2025',
        '2024',
        '2023',
        '2022'
      ],
      updateData: {
        activeYear: []
      }
    }
  },
  async mounted() {
  },
  computed: {
    ...mapState({
      campaignUpdated: state => state.campaign.campaignUpdated
    })
  },
  watch: {
    value: async function(newValue) {
      this.updateData = {
        activeYear: []
      }
    }
  },
  methods: {
    async save() {
      for (let campaign of this.campaigns) {
        this.isLoading = true
        let newUpdateData = [
          {
            id: campaign.campaignID,
            activeYear: this.updateData.activeYear
          }
        ]
        await this.$store.dispatch('campaign/updateCampaignByIds', newUpdateData)
      }
      this.isLoading = false
      if (this.campaignUpdated) {
        this.$swal({
          text: 'Successfully Updated.',
          type: 'success'
        })
        this.$emit('updated')
        this.close()
      } else {
        this.$swal({
          text: 'Error Updating Active Year!',
          type: 'error'
        })
      }
    },
    close() {
      this.$emit('input')
    }
  }
};
</script>



// WEBPACK FOOTER //
// ActiveYearModal.vue?9e32e4c8